import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

// Ring vouchers are Shopify gift card products; amounts are their variants
// (lib/gifting/voucherOffer.server.ts, Slack canvas "Gift card products").

/** Gift card product handle per website store. EUR and CAD are price-list priced. */
export const VOUCHER_PRODUCT_HANDLES: Partial<Record<ShopifyStore, string>> = {
  [ShopifyStore.US]: 'ultrahuman-gift-card',
  [ShopifyStore.CA]: 'ultrahuman-gift-card-cad',
  [ShopifyStore.GB]: 'ultrahuman-gift-card',
  [ShopifyStore.EU]: 'ultrahuman-gift-card-eur',
  [ShopifyStore.IN]: 'ultrahuman-gift-card',
  [ShopifyStore.AE]: 'ultrahuman-gift-card',
  [ShopifyStore.ROW]: 'ultrahuman-gift-card',
};

/** Shopify sends a scheduled card at most 90 days ahead. */
export const VOUCHER_SCHEDULE_MAX_DAYS = 90;

export type MetalFinish = 'aster-black' | 'bionic-gold' | 'space-silver';
export type IllustratedFinish = 'holidays' | 'diwali' | 'birthday' | 'baby';
export type PatternFinish = 'marble' | 'halftone' | 'prism';
export type VoucherFinish = MetalFinish | IllustratedFinish | PatternFinish;

// Picker order from the design. Aster Black isn't offered there but still renders.
export const VOUCHER_FINISHES: readonly VoucherFinish[] = [
  'holidays',
  'diwali',
  'birthday',
  'baby',
  'marble',
  'halftone',
  'prism',
  'bionic-gold',
  'space-silver',
];

export const VOUCHER_DEFAULT_FINISH: VoucherFinish = 'holidays';

// FROZEN `Card design` values: the gift card email template in all 5 Shopify
// stores keys on these exact strings, and checkout shows them. Never translate;
// a rename needs the template edited in every store first.
export const VOUCHER_DESIGN_NAMES: Record<VoucherFinish, string> = {
  holidays: 'Happy holidays',
  diwali: 'Happy Diwali',
  birthday: 'Happy birthday',
  baby: 'Welcome to parenthood',
  marble: 'Emerald',
  halftone: 'Pulse',
  prism: 'Prism',
  'aster-black': 'Aster Black',
  'bionic-gold': 'Bionic Gold',
  'space-silver': 'Space Silver',
};

const ILLUSTRATED = new Set<VoucherFinish>([
  'holidays',
  'diwali',
  'birthday',
  'baby',
]);
const PATTERN = new Set<VoucherFinish>(['marble', 'halftone', 'prism']);

export const isIllustratedFinish = (f: VoucherFinish): f is IllustratedFinish =>
  ILLUSTRATED.has(f);
export const isPatternFinish = (f: VoucherFinish): f is PatternFinish =>
  PATTERN.has(f);

/** Swatch file under voucher/ on S3 (the metals are PNG, the artwork JPG). */
export const voucherSwatchFile = (f: VoucherFinish): string =>
  isIllustratedFinish(f) || isPatternFinish(f)
    ? `swatch-${f}.jpg`
    : `swatch-${f}.png`;

export const VOUCHER_MESSAGE_MAX = 160;
